export default {
  debounce: function (fn, wait) {
    let timer;
    return function (...args) {
      if (timer) {
        clearTimeout(timer); // clear any pre-existing timer
      }
      const context = this; // get the current context
      timer = setTimeout(() => {
        fn.apply(context, args); // call the function if time expires
      }, wait);
    };
  },
  distinct: function(array) {
    return array.filter((value, index, arr) => arr.indexOf(value) === index);
  }
};
